import type { Infer } from 'superstruct';
import { literal, nullable, object, union } from 'superstruct';

import { ViewGoogleAdsTemplateDto } from '@adflow/shared/data-google-ads';

import type { HistoryEntityType } from './history-types';

// This is not used yet but is prepared for future use if we will want to show History log

export const ViewHistoryGoogleAdsTemplateDto1 = object({
	type: literal('GoogleAdsTemplate' satisfies HistoryEntityType),
	old: nullable(ViewGoogleAdsTemplateDto),
	new: ViewGoogleAdsTemplateDto,
});
export type ViewHistoryGoogleAdsTemplateDto1 = Infer<
	typeof ViewHistoryGoogleAdsTemplateDto1
>;

export const ViewHistoryDataDto = union([ViewHistoryGoogleAdsTemplateDto1]);
export type ViewHistoryDataDto = Infer<typeof ViewHistoryDataDto>;
